const permissions = {
  RewardProgramAccess: "RewardProgramAccess"
}

export default permissions;